<div>
  <div class="flex gap-3">
    <p class="pi pi-exclamation-triangle text-3xl icon p-error mt-0"></p>
    <div class="flex flex-column w-full">
      <p [innerHTML]="data.bodyContent" class="m-0" data-test-id="warningDialog.clearCartBody"></p>
      <div class="flex mt-3 justify-content-end">
        @if (!!data.cancelText) {
          <p-button
            data-test-id="warningDialog.cancelButton"
            outlined="true"
            [label]="data.cancelText"
            class="mr-2"
            (click)="closeDialog()" />
        }

        @if (!!data.confirmText) {
          <p-button
            data-test-id="warningDialog.confirmButton"
            [label]="data.confirmText"
            (click)="closeDialogWithConfirm()" />
        }
      </div>
    </div>
  </div>
</div>
